export const AGREEMENT_TEMPLATE_META = {
	landlord: {
		title: "Landlord Agreement Templates",
		description:
			"Upload master PDFs, position variables (including static text and signature images), re-upload PDFs when needed, and preview filled agreements before WhatsApp onboarding goes live.",
		defaultCode: "LANDLORD_ONBOARDING",
		sourceChannels: ["WHATSAPP", "SELF_SERVICE", "ANY"],
		includeCommissionRate: true,
		basePath: "/agreement-templates",
		newPath: "/agreement-templates/new",
		editPath: (id) => `/agreement-templates/${id}/edit`,
	},
	tenant: {
		title: "Tenant Agreement Templates",
		description:
			"Configure tenant onboarding agreement PDFs. Position variables (including static text and signature images), re-upload PDFs when needed, preview filled agreements, then generate per occupancy from tenant payments.",
		defaultCode: "TENANT_ONBOARDING",
		sourceChannels: ["ADMIN", "WHATSAPP", "SELF_SERVICE", "ANY"],
		includeCommissionRate: false,
		basePath: "/agreement-templates/tenant",
		newPath: "/agreement-templates/tenant/new",
		editPath: (id) => `/agreement-templates/tenant/${id}/edit`,
	},
};

export const LANDLORD_PREVIEW_DEFAULTS = {
	first_name: "Jane",
	last_name: "Doe",
	business_name: "Jane Properties Ltd",
	phone_number: "0771234567",
	landlord_payment_mode: "MOBILE_MONEY",
	landlord_payment_account: "0771234567",
	landlord_mobile_registered_name: "Jane Doe",
	payout_frequency: "MONTHLY",
	pay_day: "7",
};

export const TENANT_PREVIEW_DEFAULTS = {
	tenant_name: "John Doe",
	first_name: "John",
	last_name: "Doe",
	tenant_number: "RB5932350",
	phone_number: "0777127222",
	property_name: "Sunset Apartments",
	unit_name: "A1",
	property_location: "Kampala",
	landlord_name: "ABC Properties",
	rent_amount: "500000",
	security_deposit: "500000",
	occupancy_start_date: "2026-01-15",
};
